module.exports = __webpack_public_path__ + "assets/SquareInTriangle.f085c8c01ad9ffdbec8920a9e35c317e.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/SquareInTriangle.gmt
// module id = 1003
// module chunks = 0